import FeesCard from "./FeesCard";

export default function Class2() {
  return (
    <FeesCard
      badge="Class 2"
      title="💰 Class 2 Tuition Details"
      className="2nd Standard"
      fee="₹800"
      days="Monday – Saturday"
      time="4:30 PM – 7:30 PM"
      subjects={[
        "English (Reading, Writing & Grammar)",
        "Mathematics (Tables & Operations)",
        "EVS (Science & Social Basics)",
        "School homework & test preparation"
      ]}
      approach={[
        "Strong focus on fundamentals",
        "Weekly revision tests",
        "Personal guidance",
        "Encouraging learning environment"
      ]}
      note="₹500 extra for evening snacks / milk.
      Self pickup & drop only."
    /> 
  );
}